import React from 'react';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import {KeyboardDatePicker} from "@material-ui/pickers";

const RenderDateField = ({
                           input: { onChange, value },
                           label,
                           meta: { touched, error },
                           clearable
                         }) => (
  <KeyboardDatePicker
    clearable={clearable}
    label={label}
    error={!!(touched && error)}
    value={!value ? null : new Date(value)}
    onChange={onChange}
    format={"DD/MM/YYYY"}
  />
);

export default RenderDateField



// WEBPACK FOOTER //
// ./src/components/inputs/renderDateField.js